import { seoResolver } from "../../modules/app-route";
import { AppRoutes } from "../../modules/app-route/models/app-route.model";

export const BOOTE_ROUTES: AppRoutes = [
    {
        path: "eissegeln",
        loadComponent: () => import('./components/boote-eissegeln/boote-eissegeln.component').then(mod => mod.BooteEissegelnComponent),
        title: 'Boote, Eissegeln',
        data: {
            header: {
                type: 'back_button',
            },
            meta: {
                description: 'Eissegel-Video aus der Perspektive des Seglers auf einem DN-Schlitten bei einer Runde über das Ostenmeer'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: "",
        loadComponent: () => import('./components/boote-carousel/boote-carousel.component').then(mod => mod.BooteCarouselComponent),
        outlet: "carousel"
    },
    {
        path: "",
        loadComponent: () => import('./components/boote-home/boote-home.component').then(mod => mod.BooteHomeComponent),
        title: 'YSTM - Boote',
        data: {
            meta: {
                description: 'Boote und Bretter, P-Boot, R-Boot, H-Jolle, FD, Katamaran, Topcat, A-Cat, Dart, Tornado, F-18, Club-Boote, Auswanderer, Laser, ILCA, Opti, 49er, 29er, Windsurfen, Regatten, Kran, Wasserrettung, Eissegeln, Liegeplatz'
            }
        },
        resolve: { seo: seoResolver },
    },
    {
        path: '**',
        redirectTo: '',
        pathMatch: 'full'
    }
];